import React, { useCallback, useEffect, useRef } from "react";
import { IconButton, Stack } from "@mui/material";
import {
  StyledSelectInput,
  StyledTextInput,
} from "../../../../../../Reuse/FormInput";
import { droneStatus, droneTypes } from "../../../Context";
import { useWatch } from "react-hook-form";
import { DeleteIcon } from "../../../../../../Reuse/Icon";
import { setDroneData } from "../utils/setDroneData";
import { selectUserDatas } from "../../../../../../store/userSlice";
import { useSelector } from "react-redux";
import { PlusCircleFilled } from "@ant-design/icons";

const width = 70;

const DroneRow = ({
  index,
  control,
  error,
  showAuto,
  setValue,
  openPopup,
  setAvailableDrone,
}) => {
  const userData = useSelector(selectUserDatas);
  const drone = useWatch({ control, name: `drones.${index}` });
  const prevDroneRef = useRef({});

  useEffect(() => {
    if (!drone.isUpdate) {
      if (drone.id && !prevDroneRef.current?.id) {
        // New drone added
        prevDroneRef.current = drone;
      } else if (
        prevDroneRef.current?.id &&
        drone.device_id !== prevDroneRef.current?.device_id
      ) {
        setAvailableDrone(prevDroneRef.current?.device_id);
        prevDroneRef.current = {};
        setValue(`drones.${index}.id`, "");
      }
    }
  }, [drone]);

  const isvalue =
    !!drone.type ||
    !!drone.droneId ||
    !!drone.id ||
    !!drone.device_id ||
    !!drone.drone_ip;

  const handleLabelChange = useCallback((e, onChange, status) => {
    onChange(e);
  }, []);

  const clearRow = useCallback(() => {
    if (drone.device_id && drone.isUpdate === false) {
      setAvailableDrone(drone.device_id);
    }
    Object.entries(setDroneData()).forEach(([key, value]) => {
      setValue(`drones.${index}.${key}`, value);
    });
  }, [index, setValue, setAvailableDrone, drone]);

  const isDroneEdited = userData.data?.role?.drone_edit_access || false;

  return (
    <Stack direction="row" flexGrow={1} gap={0.75}>
      <StyledSelectInput
        showError={false}
        name={`drones.${index}.type`}
        control={control}
        optionList={droneTypes}
        label="Drone Type"
        sx={{ width: 138 }}
        onChange={handleLabelChange}
        placeholder={"Select"}
      />
      <StyledTextInput
        control={control}
        name={`drones.${index}.droneId`}
        label="ID"
        showError={false}
        sx={{ width, minWidth: width }}
        placeholder="-"
        onChange={handleLabelChange}
      />
      <StyledTextInput
        control={control}
        name={`drones.${index}.drone_ip`}
        label="Drone IP"
        showError={false}
        sx={{ width, minWidth: width }}
        placeholder={"-"}
        onChange={handleLabelChange}
      />
      <StyledTextInput
        label="Device Id"
        name={`drones.${index}.device_id`}
        sx={{ width, minWidth: width }}
        control={control}
        placeholder={"-"}
        showError={false}
        onChange={handleLabelChange}
      />
      <StyledSelectInput
        control={control}
        name={`drones.${index}.status`}
        optionList={droneStatus}
        label="Status"
        sx={{ width: 112 }}
        onChange={handleLabelChange}
        placeholder={"Select"}
      />
      <Stack
        flexGrow={1}
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-start"
        gap={0}
        sx={{ marginTop: 3.25 }}
      >
        {isvalue && isDroneEdited ? (
          <IconButton
            onClick={clearRow}
            sx={{ color: "#BC1B06", fontSize: 18 }}
          >
            <DeleteIcon />
          </IconButton>
        ) : null}
        <Stack direction="row" flexGrow={1}></Stack>
        {showAuto && !drone.isUpdate ? (
          <IconButton
            variant="contained"
            onClick={(e) => openPopup(e, index, "drones")}
            sx={{ fontSize: 24 }}
          >
            <PlusCircleFilled />
          </IconButton>
        ) : null}
      </Stack>
    </Stack>
  );
};

export default React.memo(DroneRow);
